import { useMedplum } from "@medplum/react-hooks";
import { buildChatContext } from "@repo/agent-chat";
import { useParams } from "@tanstack/react-router";
import { practitionerFhirIdFromProfile } from "@/shared/hooks/use-current-practitioner";
import { setChatRouteContext } from "./chat-route-context";

/**
 * Publishes where the clinician is right now, for the shared transports to read
 * at send time. Written during render so a message sent immediately after
 * navigating still carries the new route.
 *
 * Mounted once, high in the tree (`__root.tsx`'s `LayoutWrapper`) — not per
 * `AgentChat.Root` mount. `@repo/agent-chat`'s `AgentChat.Root` is purely
 * controlled and takes no router dependency (MIN-293), so this sync is an
 * app-level concern; one clinician looks at one route at a time, so "where
 * the request is being sent from" is genuinely global rather than per-surface.
 */
export function ChatRouteContextSync(): null {
  const medplum = useMedplum();
  const params = useParams({ strict: false });
  setChatRouteContext(
    buildChatContext(params as Record<string, string | undefined>, practitionerFhirIdFromProfile(medplum.getProfile())),
  );
  return null;
}
